export const getScheduleReferences = ( apiInstance: API.Client ) => ( uid: string ) => (
  apiInstance.Entity.collection( 'schedule' ).getReferences( uid )
)